import { StyledText } from '../../TopNavigationHeader.styles';
import { ProfileDetailsFlexContainer, ProfileIcon } from './DisplayProfileHeader.styles';

interface DisplayProfileHeaderProps {
  handleProfileDisplay: () => void;
  isOpen: boolean;
  nameInitials: string;
  userDisplayName: string;
}

const DisplayProfileHeader = ({
  handleProfileDisplay,
  isOpen,
  nameInitials,
  userDisplayName,
}: DisplayProfileHeaderProps) => {
  return (
    <ProfileDetailsFlexContainer
      onClick={handleProfileDisplay}
      isOpen={isOpen}
      id="profile-details-flex-container"
    >
      <ProfileIcon id="profile-icon">{nameInitials}</ProfileIcon>
      <StyledText id="user-name">{userDisplayName}</StyledText>
    </ProfileDetailsFlexContainer>
  );
};

export default DisplayProfileHeader;
